// extracted by mini-css-extract-plugin
module.exports = {"gradient":"Color_gradient__rYcIm"};